import {Inject, injectable} from 'inversify-props';

import {LoraForwarderState} from '@/model/lora/LoraForwarderState';

import {IApiService} from '@/services/IApi.service';
import {ILoraForwarderStdService} from '@/services/lora/forwarder/ILoraForwarderStd.service';
import {TypedJSON} from 'typedjson';
import {LoraPacketForwarderStats} from '@/model/lora/LoraPacketForwarderStats';

@injectable()
export abstract class LoraForwarderStdService implements ILoraForwarderStdService {

  protected path: string;

  protected timeout = 30000;

  protected statsSerializer = new TypedJSON(LoraPacketForwarderStats);

  @Inject(Symbol.for('IApiService'))
  protected apiService!: IApiService;

  protected constructor(path: string) {
    this.path = path;
  }

  public async getEnabled(): Promise<boolean> {
    return this.apiService.get(`${this.path}/enabled`);
  }

  public async getState(): Promise<LoraForwarderState> {
    return this.apiService.get(`${this.path}/state`);
  }

  public async getVersion(): Promise<string> {
    return this.apiService.get(`${this.path}/version`);
  }

  public async enable(): Promise<void> {
    return this.apiService.post(`${this.path}/enable`, null, {
      timeout: this.timeout,
    });
  }

  public async disable(): Promise<void> {
    return this.apiService.post(`${this.path}/disable`, null, {
      timeout: this.timeout,
    });
  }

  public async isEnabled(): Promise<boolean> {
    return this.apiService.get(`${this.path}/enabled`);
  }

  public async start(): Promise<void> {
    return this.apiService.post(`${this.path}/start`, null, {
      timeout: this.timeout,
    });
  }

  public async stop(): Promise<void> {
    return this.apiService.post(`${this.path}/stop`, null, {
      timeout: this.timeout,
    });
  }

  public async restart(): Promise<void> {
    return this.apiService.post(`${this.path}/restart`, null, {
      timeout: this.timeout,
    });
  }

  public async logSubscribe(): Promise<void> {
    return this.apiService.post(`${this.path}/logs/subscribe`, null);
  }

  public async logUnsubscribe(): Promise<void> {
    return this.apiService.post(`${this.path}/logs/unsubscribe`, null);
  }
}
